import React, { useContext, useRef } from "react";
import { OwcMenu, OwcListItem } from "@one/react";
import { entryType, MyLabMenuArray } from "../../constants";
import { EquipmentsContext } from "./equipments-context/context";
import { getFieldValue } from "@digitallab/grid-common-components";
// import { setCookieData } from "../../utils/helpers/cookie";
const MyEquipmentMenu = ({ params, setShowMenu, removeMyLabEquipment, showMyLab, updateMyLabEquipment, isEditMode }) => {
  const menuElement = useRef(null);
  const {
    myLabEquipment
  } = useContext(EquipmentsContext);

  let paramsValue = null;
  paramsValue = getFieldValue(params?.data, "id")?.toString();

  // const redirectWithCookie = (search, type) => {
  //   if (search) {
  //     setCookieData("searchQuery", `${search}:${type}`, 1);
  //   }
  //   const launchURL =
  //     `https://${process.env.REACT_APP_OAUTH_DOMAIN}/` +
  //     `authorize?client_id=${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}` +
  //     `&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${process.env.REACT_APP_GRAPHQL_BOOKING_ENDPOINT_CLOUDFRONT}`;
  //   window.open(launchURL);
  // };
  const redirectWithoutCookie = (inventoryId, option) => {
    let launchURL = "";
    if (option === "bookEquipment" || option === "bookCluster") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_BOOKING_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    if (option === "viewLogbook") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_LOGBOOK_ENDPOINT_CLOUDFRONT}cover-sheet/${inventoryId}`;
    }
    if (option === "viewMonitoring") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_MONITORING_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    if (option === "viewRepo") {
      launchURL = `${process.env.REACT_APP_GRAPHQL_REPO_ENDPOINT_CLOUDFRONT}equipmentList/${inventoryId}`;
    }
    window.open(launchURL);
  };

  const handleClick = (option) => {
    setShowMenu(false);
    switch (option) {
      case "bookEquipment":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewLogbook":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewMonitoring":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "viewRepo":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "bookCluster":
        redirectWithoutCookie(getFieldValue(params?.data, "id"), option);
        break;
      case "remove":
        removeMyLabEquipment(getFieldValue(params?.data, "id"));
        break;
      case "add":
        updateMyLabEquipment(getFieldValue(params?.data, "id"));
        break;
      default:
    }
  };

  return (
    <div>
      <OwcMenu
        ref={menuElement}
        visible={true}
        onClickOutside={() => setShowMenu(false)}
        anchor={getFieldValue(params?.data, "id")}
        disable-portal={true}
        strategy="fixed"
      >
        {MyLabMenuArray.map((item) => {
          let canShow = item.availableFor.indexOf(getFieldValue(params?.data, "entry_type")) !== -1;
          if (item.key === "bookEquipment" && getFieldValue(params?.data, "entry_type") === entryType.standaloneEquipment) {
            canShow = getFieldValue(params?.data, "is_bookable") !== undefined && getFieldValue(params?.data, "is_bookable") === "true";
          }
          if (item.key === "bookCluster" && getFieldValue(params?.data, "entry_type") === entryType?.cluster) {
            canShow = getFieldValue(params?.data, "is_bookable") !== undefined && getFieldValue(params?.data, "is_bookable") === "true";
          }

          // if (
          //   item.key === "viewLogbook" &&
          //   allMegaclusterIds?.current?.includes(params?.data?.id[0])
          // ) {
          //   canShow =
          //     params?.data?.is_visualized !== undefined &&
          //     params?.data?.is_visualized[0] === "true";
          // }

          if (item.key === "bookCluster" && getFieldValue(params?.data, "entry_type") === entryType?.cluster) {
            canShow = getFieldValue(params?.data, "is_bookable") !== undefined && getFieldValue(params?.data, "is_bookable") === "true";
          }

          if (item.key === "viewMonitoring") {
            canShow = getFieldValue(params?.data, "is_visualized") !== undefined && getFieldValue(params?.data, "is_visualized") === "true";
          }

          if (myLabEquipment.includes(paramsValue)) {
            if (item.key === "add") {
              canShow = false
            }
            else if (item.key === "remove") {
              canShow = true
            }
          }

          if (item.key === "add" && showMyLab) {
            canShow = false;
          }

          if (item.key === "remove" && !showMyLab && isEditMode) {
            canShow = false;
          }

          if (item.key === "remove" && !showMyLab && isEditMode && myLabEquipment.includes(paramsValue)) {
            canShow = true;
          }


          return (
            canShow && (
              <OwcListItem
                onClick={() => {
                  handleClick(item.key);
                }}
              >
                {item.value}
              </OwcListItem>
            )
          );
        })}
      </OwcMenu>
    </div>
  );
};

export default MyEquipmentMenu;
